import { S2_EMAIL_TEMPLATES_PATH } from '../constants';
import { authedAxios } from '../shared/axiosWrapper';

export default {
  fetchTemplates(archive, folderId) {
    const params = {
      filter: [],
      limit: 1000,
      sort: ['name:asc'],
    };

    // Add filters
    params.filter.push('is_system:eq:false');
    if (archive != undefined) {
      params.filter.push(`is_archive:eq:${archive}`);
    } else {
      params.filter.push('is_archive:eq:false');
    }

    if (folderId != undefined) {
      params.folderId = folderId;
    }

    return authedAxios.get(S2_EMAIL_TEMPLATES_PATH, { params: params });
  },
  fetchReplyTemplates() {
    const params = {
      filter: ['is_reply:eq:true', 'is_system:eq:false'],
      limit: 1000,
      sort: ['name:asc'],
    };
    return authedAxios.get(S2_EMAIL_TEMPLATES_PATH, { params: params });
  },
  fetchTemplate(id) {
    return authedAxios.get(S2_EMAIL_TEMPLATES_PATH + id);
  },
  getSignedUrlUpload(id, contentType) {
    return authedAxios.post(S2_EMAIL_TEMPLATES_PATH + 'signed-url', {
      id,
      contentType,
    });
  },
  newTemplate(payload) {
    return authedAxios.post(S2_EMAIL_TEMPLATES_PATH, payload);
  },
  getSignedUrlDownload(id) {
    return authedAxios.get(S2_EMAIL_TEMPLATES_PATH + `signed-url/${id}`);
  },
  saveTemplate(id, payload) {
    return authedAxios.put(S2_EMAIL_TEMPLATES_PATH + id + '/', payload);
  },
  duplicateTemplate(id, name) {
    return authedAxios.post(S2_EMAIL_TEMPLATES_PATH + 'duplicate/' + id, {
      name: name,
    });
  },
  systemTemplate(id, payload) {
    return authedAxios.post(S2_EMAIL_TEMPLATES_PATH + 'system/' + id, payload);
  },
  templateStoreComplete(id) {
    return authedAxios.put(S2_EMAIL_TEMPLATES_PATH + id + '/complete');
  },
  renameTemplate(id, name) {
    return authedAxios.patch(S2_EMAIL_TEMPLATES_PATH + id + '/rename', {
      name,
    });
  },
  updateSubject(id, subject) {
    return authedAxios.patch(S2_EMAIL_TEMPLATES_PATH + id + '/subject', {
      subject,
    });
  },
  updatePreview(id, preview) {
    return authedAxios.patch(S2_EMAIL_TEMPLATES_PATH + id + '/preview', {
      preview,
    });
  },
  archiveTemplate(id, archive = true) {
    return authedAxios.patch(S2_EMAIL_TEMPLATES_PATH + id + '/archive', {
      is_archive: archive,
    });
  },
  replyTemplate(id, reply) {
    return authedAxios.put(S2_EMAIL_TEMPLATES_PATH + id + '/reply', {
      is_reply: reply,
    });
  },
  changeFolder(id, folderId) {
    return authedAxios.put(S2_EMAIL_TEMPLATES_PATH + id + '/folder', {
      folder_id: folderId,
    });
  },
  changeBrand(templateId, brandId) {
    return authedAxios.put(S2_EMAIL_TEMPLATES_PATH + templateId + '/brand', {brand_id: brandId});
  },
  patchTemplate(templateId, payload) {
    return authedAxios.patch(S2_EMAIL_TEMPLATES_PATH + templateId, payload);
  },

  // Gallery
  async getGallery({
    type,
    sort,
    limit,
    page,
    templateTypes,
    templateSeasons,
    templateFeatures,
    templateIndustries,
  }) {
    return authedAxios.get(S2_EMAIL_TEMPLATES_PATH + 'public-templates', {
      params: {
        type,
        sort,
        limit,
        page,
        templateTypes,
        templateSeasons,
        templateFeatures,
        templateIndustries,
      },
    });
  },
  async fetchGalleryTemplate(id) {
    return authedAxios.get(S2_EMAIL_TEMPLATES_PATH + `public-template/${id}`);
  },

  /**
   * Get Template Merge
   *
   * Required a template and might need to pull data via the backend
   *
   * @param {*} template
   * @param {*} contactId
   * @param {*} campaignId
   * @param {*} reservationId
   * @param {*} leadId
   * @returns
   */
  getTemplateMerge(templateId, contactId, campaignId, reservationId, leadId, cartAbandonId, airbnbThreadId) {
    const payload = {
      template_id: templateId,
      // Content will be provided with template id of 0
      content: undefined,
    };
    if (contactId) {
      payload.contact_id = contactId;
    }
    if (campaignId) {
      payload.campaign_id = campaignId;
    }
    if (reservationId) {
      payload.reservation_id = reservationId;
    }
    if (leadId) {
      payload.lead_id = leadId;
    }
    if (cartAbandonId) {
      payload.cart_abandon_id = cartAbandonId;
    }
    if (airbnbThreadId) {
      payload.airbnb_message_thread = airbnbThreadId;
    }
    return authedAxios.post(S2_EMAIL_TEMPLATES_PATH + 'merge/', payload);
  },
};
